var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"native_img_style",attrs:{"src":_vm.nativeImgPath,"alt":_vm.nativeData.name}})}
var staticRenderFns = []

export { render, staticRenderFns }